var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusCrazy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.594 0l.098.16c-.098 3.104-.147 4.888-.147 5.352a.51.51 0 00-.05.214c.033 0 .05.018.05.053.589-.035 1.03-.053 1.325-.053h3.092l.147-.107.05.16v4.388c0 .143-.36.214-1.08.214h-.05c-.85 0-2.077.018-3.68.054C9.25 14.145 9.136 16 9.005 16h-.344c-.785 0-2.028-.053-3.73-.16l-.098-.108a499.697 499.697 0 01-.098-5.137c-1.047 0-2.552.036-4.515.107l-.05-.16V6.1c0-.107.05-.16.148-.16 2.323-.036 3.73-.054 4.22-.054V5.78c0-.892-.048-2.55-.146-4.976C4.719.73 6.452.463 9.594 0z",
    fill: "#000"
  })));
}
export default SvgIconPlusCrazy;